import React from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function PricingCards() {
  return <section className="py-12 px-4 max-w-6xl mx-auto pt-[0px] pb-[0px] pl-[0px] pr-[0px] space-y-[0px]" id="pricing" data-id="element-221">
      <FadeIn data-id="element-222">
        <h2 className="text-4xl md:text-5xl font-black text-center mb-12" data-id="element-223">
          ELEGÍ TU MEGAPACK
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-224">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-225">
          <div className="bg-gray-900 border border-gray-800 rounded-3xl p-8 h-full flex flex-col relative pt-[0px] pb-[0px]" data-id="element-226">
            <div className="mb-6" data-id="element-227">
              <h3 className="text-2xl font-bold text-white flex items-center gap-2 mb-2" data-id="element-228">
                <span data-id="element-229">📘</span> MEGAPACK NUTRICIONISTA LISTA
              </h3>
              <p className="text-gray-400 font-medium" data-id="element-230">6 Tomos + 6 Bonos</p>
            </div>

            <div className="mb-8" data-id="element-231">
              <div className="text-red-400 line-through text-xl font-medium mb-1" data-id="element-232">
                $95.000
              </div>
              <div className="text-5xl font-black text-white flex items-baseline gap-2" data-id="element-233">
                $19.990{' '}
                <span className="text-xl text-gray-400 font-medium" data-id="element-234">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-235">
              <li className="flex items-start gap-3" data-id="element-236">
                <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-237" />
                <span className="text-gray-300" data-id="element-238">
                  Acceso a los 6 Tomos completos
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-239">
                <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-240" />
                <span className="text-gray-300" data-id="element-241">Los 6 Bonos de regalo</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-242">
                <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-243" />
                <span className="text-gray-300" data-id="element-244">
                  Actualizaciones de por vida
                </span>
              </li>
            </ul>

            <a href="https://www.tumanualdigital.com/cart/44024762368036:1" className="w-full block text-center py-4 px-6 rounded-xl font-bold text-lg bg-gray-800 hover:bg-gray-700 text-white transition-colors border border-gray-700" data-id="element-245">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-246">
          <div className="bg-gradient-to-b from-gray-900 to-black border-2 border-green-500 rounded-3xl p-8 h-full flex flex-col relative transform md:-translate-y-4 shadow-[0_0_30px_rgba(34,197,94,0.15)]" data-id="element-247">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-green-500 text-black font-bold px-4 py-1.5 rounded-full text-sm flex items-center gap-1 whitespace-nowrap" data-id="element-248">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="mb-6 mt-2" data-id="element-249">
              <h3 className="text-2xl font-bold text-white flex items-center gap-2 mb-2" data-id="element-250">
                <span data-id="element-251">🏆</span> MEGAPACK + CEREBRO DIGITAL
              </h3>
              <p className="text-green-400 font-medium" data-id="element-252">
                6 Tomos + 6 Bonos + Sistema de Organización y Automatización
              </p>
            </div>

            <div className="mb-8" data-id="element-253">
              <div className="text-red-400 line-through text-xl font-medium mb-1" data-id="element-254">
                $130.000
              </div>
              <div className="text-5xl font-black text-white flex items-baseline gap-2" data-id="element-255">
                $27.990{' '}
                <span className="text-xl text-gray-400 font-medium" data-id="element-256">ARS</span>
              </div>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-257">
              <li className="flex items-start gap-3" data-id="element-258">
                <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-259" />
                <span className="text-gray-200 font-medium" data-id="element-260">
                  Todo lo del Megapack Básico
                </span>
              </li>
              <li className="flex items-start gap-3 bg-green-900/20 p-2 rounded-lg -mx-2" data-id="element-261">
                <Check className="text-green-400 shrink-0 mt-1" size={20} data-id="element-262" />
                <span className="text-green-100 font-bold" data-id="element-263">
                  Sistema Cerebro Digital (7 módulos)
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-264">
                <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-265" />
                <span className="text-gray-300" data-id="element-266">
                  Plantillas de Drive automatizadas
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-267">
                <Check className="text-green-500 shrink-0 mt-1" size={20} data-id="element-268" />
                <span className="text-gray-300" data-id="element-269">
                  Scripts de WhatsApp Business
                </span>
              </li>
            </ul>

            <a href="https://www.tumanualdigital.com/cart/44024763645988:1" className="w-full block text-center py-4 px-6 rounded-xl font-bold text-lg bg-green-500 hover:bg-green-400 text-black transition-all hover:scale-[1.02] shadow-lg" data-id="element-270">
              → QUIERO EL MEGAPACK + CEREBRO DIGITAL
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}